module.exports = __webpack_public_path__ + "img/eye-intelligence-reports.0d372d3b.webp";